<div class="quarantine-placement-holder">
  <div class="body-wrapper">
    <div class="form-container">


      <form [formGroup]="form" class="form-container">

        <div class="container">
          <!--          row 1-->
          <div class="row">
            <div class="col-7">
              <div class="title-holder">
                <ng-container [ngSwitch]="true">
                  <div class="icon" *ngSwitchCase='isCreateQuarantinePlacement || isCreateQuarantineRemoval'>
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="9.25" y="1.375" width="3.5" height="19.25" rx="1.75" fill="url(#paint0_linear_29453_866)" stroke="url(#paint1_linear_29453_866)"/>
                      <rect x="20.625" y="9.25" width="3.5" height="19.25" rx="1.75" transform="rotate(90 20.625 9.25)" fill="url(#paint2_linear_29453_866)" stroke="url(#paint3_linear_29453_866)"/>
                      <defs>
                        <linearGradient id="paint0_linear_29453_866" x1="11" y1="0.875002" x2="4.59855" y2="1.42965" gradientUnits="userSpaceOnUse">
                          <stop/>
                          <stop offset="1" stop-color="white"/>
                        </linearGradient>
                        <linearGradient id="paint1_linear_29453_866" x1="12.489" y1="-0.68269" x2="8.35044" y2="0.168649" gradientUnits="userSpaceOnUse">
                          <stop stop-color="white" stop-opacity="0"/>
                          <stop offset="0.428115" stop-color="white" stop-opacity="0.81428"/>
                          <stop offset="1" stop-color="white" stop-opacity="0"/>
                        </linearGradient>
                        <linearGradient id="paint2_linear_29453_866" x1="23.625" y1="20.1815" x2="21.5182" y2="32.1149" gradientUnits="userSpaceOnUse">
                          <stop/>
                          <stop offset="1" stop-color="white"/>
                        </linearGradient>
                        <linearGradient id="paint3_linear_29453_866" x1="24.864" y1="7.19231" x2="20.7254" y2="8.04365" gradientUnits="userSpaceOnUse">
                          <stop stop-color="white" stop-opacity="0"/>
                          <stop offset="0.428115" stop-color="white" stop-opacity="0.81428"/>
                          <stop offset="1" stop-color="white" stop-opacity="0"/>
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                  <div class="icon" *ngSwitchCase="quarantinePlacement?.documentStatus === 'DRAFT'">
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20.5442 10.4154L9.85476 21.1049H0.771472V12.0216L11.4609 1.33211L20.5442 10.4154Z" fill="url(#paint0_linear_29453_5461)" stroke="url(#paint1_linear_29453_5461)"/>
                      <defs>
                        <linearGradient id="paint0_linear_29453_5461" x1="16.3562" y1="5.52024" x2="-0.0801888" y2="-4.61088" gradientUnits="userSpaceOnUse">
                          <stop/>
                          <stop offset="1" stop-color="white"/>
                        </linearGradient>
                        <linearGradient id="paint1_linear_29453_5461" x1="20.8329" y1="7.52248" x2="9.6957" y2="4.41288" gradientUnits="userSpaceOnUse">
                          <stop stop-color="white" stop-opacity="0"/>
                          <stop offset="0.428115" stop-color="white" stop-opacity="0.81428"/>
                          <stop offset="1" stop-color="white" stop-opacity="0"/>
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                  <div class="icon" *ngSwitchCase="this.quarantinePlacement?.documentStatus === 'CONFIRMED' || this.quarantinePlacement?.documentStatus === 'CANCELLED'">
                    <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3.83461 12.8441L3.50599 16.1614C3.33154 17.9204 4.20357 19.6189 5.73445 20.5027L11.433 23.7928C12.9566 24.6725 14.8678 23.7441 15.1489 22.0422L15.1712 21.8746L15.4033 19.5233L3.83461 12.8441Z" fill="url(#paint0_linear_29453_6801)" stroke="url(#paint1_linear_29453_6801)"/>
                      <path d="M21.8909 14.9757L9.37159 7.74765L3.41238 12.024L15.9317 19.2521L21.8909 14.9757Z" fill="url(#paint2_linear_29453_6801)"/>
                      <path d="M19.0135 6.17374L12.5319 2.43155C11.6472 1.92075 10.5446 2.42613 10.3216 3.3848L10.2888 3.58234L9.90285 7.4754L21.4716 14.1546L21.7371 11.4798C21.9503 9.32985 20.8846 7.25399 19.0135 6.17374Z" fill="url(#paint3_linear_29453_6801)" stroke="url(#paint4_linear_29453_6801)"/>
                      <defs>
                        <linearGradient id="paint0_linear_29453_6801" x1="10.9823" y1="16.3935" x2="10.795" y2="26.2283" gradientUnits="userSpaceOnUse">
                          <stop/>
                          <stop offset="1" stop-color="white"/>
                        </linearGradient>
                        <linearGradient id="paint1_linear_29453_6801" x1="6.43948" y1="16.2936" x2="5.13121" y2="23.7004" gradientUnits="userSpaceOnUse">
                          <stop stop-color="white" stop-opacity="0"/>
                          <stop offset="0.428115" stop-color="white" stop-opacity="0.81428"/>
                          <stop offset="1" stop-color="white" stop-opacity="0"/>
                        </linearGradient>
                        <linearGradient id="paint2_linear_29453_6801" x1="8.65901" y1="15.1148" x2="20.9896" y2="2.78427" gradientUnits="userSpaceOnUse">
                          <stop stop-color="white"/>
                          <stop offset="1"/>
                        </linearGradient>
                        <linearGradient id="paint3_linear_29453_6801" x1="17.6659" y1="4.8183" x2="17.4786" y2="14.6531" gradientUnits="userSpaceOnUse">
                          <stop/>
                          <stop offset="1" stop-color="white"/>
                        </linearGradient>
                        <linearGradient id="paint4_linear_29453_6801" x1="12.9143" y1="1.48139" x2="12.0731" y2="7.82221" gradientUnits="userSpaceOnUse">
                          <stop stop-color="white" stop-opacity="0"/>
                          <stop offset="0.428115" stop-color="#797979" stop-opacity="0.81428"/>
                          <stop offset="1" stop-color="white" stop-opacity="0"/>
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                </ng-container>
                <div class="title-wrapper">
                  <h2 class="form-title">
                    {{ pageTitle }}
                  </h2>
                  <p
                      *ngIf="isCreateQuarantineRemoval || isEditQuarantineRemoval"
                      class="subtitle"
                  >
                    <span>
                    <svg fill="none" height="13" viewBox="0 0 14 13" width="14" xmlns="http://www.w3.org/2000/svg">
                      <path clip-rule="evenodd" d="M8.21967 12.0303C7.92678 11.7374 7.92678 11.2626 8.21967 10.9697L11.1893 8L4.75 8C2.1267 8 3.41849e-06 5.87337 3.64783e-06 3.25L3.86638e-06 0.750002C3.9026e-06 0.335802 0.335804 1.68832e-06 0.750004 1.72453e-06C1.1642 1.76074e-06 1.5 0.335802 1.5 0.750002L1.5 3.25C1.5 5.04493 2.9551 6.5 4.75 6.5L11.1893 6.5L8.21967 3.5303C7.92678 3.2374 7.92678 2.7626 8.21967 2.4697C8.51256 2.1768 8.98744 2.1768 9.28033 2.4697L13.5303 6.71967C13.8232 7.01256 13.8232 7.48744 13.5303 7.78033L9.28033 12.0303C8.98744 12.3232 8.51256 12.3232 8.21967 12.0303Z"
                            fill="#666666"
                            fill-rule="evenodd"/>
                    </svg>
                  </span>
                    для розміщення у карантин № {{ isCreateQuarantineRemoval ? history.state.quarantinePlacement?.id : history.state.quarantinePlacement?.parentDocumentId }}
                  </p>
                </div>
              </div>
            </div>
            <div class="col-5 text-end">
              <button *ngIf="showRefreshButton && canMakeActions"
                      class="button button-refresh"
                      (click)="refreshList()"
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.0851 3.40141C10.1668 3.31809 10.2315 3.21914 10.2757 3.11023C10.3199 3.00132 10.3426 2.88458 10.3426 2.76668C10.3426 2.64878 10.3199 2.53204 10.2757 2.42313C10.2315 2.31422 10.1668 2.21528 10.0851 2.13195L8.25573 0.262912C8.09096 0.0945724 7.86749 0 7.63447 0C7.40146 0 7.17798 0.0945724 7.01322 0.262912C6.84845 0.431252 6.75588 0.65957 6.75588 0.897639C6.75588 1.13571 6.84845 1.36403 7.01322 1.53237L7.37616 1.90169C6.29992 2.0167 5.27415 2.42692 4.40747 3.08892C3.54079 3.75091 2.86546 4.64004 2.453 5.66215C2.04053 6.68426 1.90628 7.80131 2.06445 8.895C2.22263 9.9887 2.66735 11.0183 3.35152 11.8749C3.49883 12.0593 3.71179 12.1764 3.94357 12.2003C4.17536 12.2243 4.40697 12.1532 4.58746 12.0027C4.76794 11.8522 4.88252 11.6347 4.90599 11.3979C4.92946 11.161 4.85989 10.9244 4.71258 10.74C4.2435 10.1527 3.9333 9.45005 3.81292 8.70208C3.69254 7.9541 3.76618 7.18695 4.02649 6.47711C4.28681 5.76728 4.72471 5.13957 5.29653 4.65657C5.86835 4.17357 6.55411 3.85216 7.28543 3.72438L7.01322 4.001C6.84845 4.16934 6.75588 4.39766 6.75588 4.63572C6.75588 4.87379 6.84845 5.10211 7.01322 5.27045C7.17798 5.43879 7.40146 5.53336 7.63447 5.53336C7.86749 5.53336 8.09096 5.43879 8.25573 5.27045L10.0851 3.40141ZM11.111 3.74531C11.027 3.82647 10.9595 3.92379 10.9124 4.03167C10.8653 4.13954 10.8395 4.25587 10.8365 4.37395C10.8335 4.49204 10.8534 4.60957 10.895 4.71979C10.9366 4.83002 10.999 4.93077 11.0788 5.01626C11.6082 5.58598 11.9761 6.2919 12.1433 7.05863C12.3105 7.82536 12.2707 8.6241 12.0281 9.36951C11.7856 10.1149 11.3494 10.779 10.7662 11.2909C10.1829 11.8027 9.47458 12.1431 8.71674 12.2756L8.98748 11.999C9.15225 11.8307 9.24482 11.6023 9.24482 11.3643C9.24482 11.1262 9.15225 10.8979 8.98748 10.7295C8.82272 10.5612 8.59924 10.4666 8.36623 10.4666C8.13321 10.4666 7.90974 10.5612 7.74497 10.7295L5.91559 12.5986C5.83394 12.6819 5.76918 12.7809 5.72499 12.8898C5.6808 12.9987 5.65805 13.1154 5.65805 13.2333C5.65805 13.3512 5.6808 13.468 5.72499 13.5769C5.76918 13.6858 5.83394 13.7847 5.91559 13.868L7.74497 15.7371C7.90974 15.9054 8.13321 16 8.36623 16C8.59924 16 8.82272 15.9054 8.98748 15.7371C9.15225 15.5687 9.24482 15.3404 9.24482 15.1024C9.24482 14.8643 9.15225 14.636 8.98748 14.4676L8.62454 14.0968C9.7386 13.9776 10.7978 13.5422 11.6821 12.8399C12.5665 12.1375 13.2408 11.1962 13.6287 10.1226C14.0166 9.04899 14.1026 7.88587 13.877 6.76489C13.6514 5.64391 13.1232 4.60984 12.3521 3.7797C12.1917 3.60726 11.9709 3.50693 11.7382 3.50076C11.5055 3.49459 11.2799 3.5816 11.111 3.74531Z" fill="#333333"/>
                </svg>
                Оновити список
              </button>
            </div>
          </div>

          <div class="row">
            <div class="col-4">
              <div class="row">
                <div class="col-3">
                  <label>Статус</label>
                  <div [documentStatusHighlight]="documentStatus" class="subtitle">
                    {{ statusTypes[documentStatus] }}
                  </div>
                </div>
                <div class="col-9">
                  <label>Організація-ініціатор</label>
                  <div class="subtitle">{{ quarantinePlacement?.organizationName || currentOrganisation?.fullName }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <div class="form-group">
                    <label>Документ</label>
                    <select class="invalid" formControlName="documentType" id="documentType">
                      <ng-container *ngFor="let item of documentTypes">
                        <option [value]="item.name">{{ item.nameUa }}</option>
                      </ng-container>
                    </select>
                    <p
                        *ngIf="form.controls['documentType'].invalid && form.controls['documentType'].touched"
                        class="error-massage">
                      Поле обов'язкове до заповнення
                    </p>
                  </div>
                </div>
                <div class="col-6">
                  <div *ngIf="showDifferentDocType" class="form-group">
                    <label for="differentDocType">Iнший тип документу</label>
                    <input class="invalid" formControlName="differentDocType" id="differentDocType" placeholder="Номер"
                           type="text"/>
                    <p *ngIf="form.controls['differentDocType'].invalid && form.controls['differentDocType'].touched"
                       class="error-massage">
                      Поле обов'язкове до заповнення
                    </p>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="isCreateQuarantinePlacement || isEditQuarantinePlacement">
                <div class="col-12">
                  <div class="form-group">
                    <label>Заклад</label>
                    <div class="flex justify-content-around mb-sm-1">

                      <ng-container *ngFor="let item of organisationsTypesList">
                        <label class="flex align-items-center">
                          <input
                              [value]="item['value']"
                              class="m-sm-1"
                              formControlName="quarantineOrganization"
                              name="quarantineOrganization"
                              type="radio">
                          <span class="subtitle">{{ item['description'] }}</span>
                        </label><br>
                      </ng-container>

                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div class="col-4">
              <div class="row">
                <div class="col-6">
                  <label>ЄДРПОУ ініціатора</label>
                  <div class="subtitle">{{ quarantinePlacement?.organizationCode || userData.organizationCode }}</div>
                </div>
                <div class="col-6" *ngIf="isVisibleTotalAmount">
                  <div class="amount-holder flex flex-row">
                    <div class="amount-holder-icon">
                      <span>
                        <svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M0 11.424V9.52L3.52 5.44L0.144 1.792V0H8.352V1.984H4.592C4.37867 1.984 4.13867 1.97867 3.872 1.968C3.616 1.95733 3.33867 1.936 3.04 1.904L5.904 5.072V5.68L2.56 9.52C2.93333 9.488 3.27467 9.46667 3.584 9.456C3.904 9.43467 4.24533 9.424 4.608 9.424H8.496V11.424H0Z" fill="#333333"/>
                        </svg>
                      </span>
                    </div>
                    <div class="amount-holder-content">
                      <label>{{ totalAmountText }}</label>
                      <div class="subtitle">{{ quarantinePlacement?.totalAmount === null ? '-' : quarantinePlacement?.totalAmount }}</div>
                    </div>
                  </div>

                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <div class="form-group">
                    <label for="documentNumber">№ Документа</label>
                    <input
                        class="invalid"
                        formControlName="documentNumber"
                        id="documentNumber"
                        placeholder="Номер"
                        type="text"
                    />
                    <p
                        *ngIf="form.controls['documentNumber'].invalid && form.controls['documentNumber'].touched"
                        class="error-massage">
                      Поле обов'язкове до заповнення
                    </p>
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-group">
                    <label for="documentDate">Дата документа</label>
                    <input
                        [readOnly]="form.controls['orderDate'].disabled"
                        formControlName="orderDate"
                        id="documentDate"
                        placeholder="ДД.ММ.РРРР"
                        type="date"/>
                    <p
                        *ngIf="form.controls['orderDate'].invalid && form.controls['documentType'].touched"
                        class="error-massage">
                      Поле обов'язкове до заповнення
                    </p>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="showSubInstitutions && (isCreateQuarantinePlacement || isEditQuarantinePlacement)">
                <div class="col-12">
                  <app-dropdown
                      (itemSelected)="selectChildOrganisation($event)"
                      [defaultSelectedValues]="organisationChildrenForFormSelected"
                      [disabled]="form.controls['institutionIds'].disabled"
                      [items]="organisationChildrenForForm"
                      [multipleSelect]="true"
                      placeholder="Обрати заклад"
                  ></app-dropdown>
                  <p
                      *ngIf="form.controls['institutionIds'].invalid && form.controls['institutionIds'].touched"
                      class="error-massage">
                    Поле обов'язкове до заповнення
                  </p>
                </div>

              </div>

            </div>
            <div class="col-4">
              <div class="row">
                <div class="col-6">
                  <label>Створив</label>
                  <div class="subtitle">{{ userName }}</div>
                </div>
                <div class="col-6" *ngIf="editName">
                  <label>Оновив</label>
                  <div class="subtitle">{{ editName }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label for="comment">Коментар</label>
                    <textarea formControlName="comment" id="comment" placeholder="Коментар"></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <app-create-table
        (onSelectedChanged)="form.controls['quarantineScope'].setValue($event)"
        *ngIf="isNewPlacementTable"
        [organisationId]="currentOrganisation?.id"
        [institutionIds]="institutionIdsForSearch"
    ></app-create-table>
    <app-edit-quarantine-placement-table
        *ngIf="!isNewPlacementTable"
        (onRefreshList)="refreshTransactionDocument($event)"
        [isRefreshing]="isRefreshing"
        [documentId]="history.state.quarantinePlacement?.id"
        [isRemoval]="history.state.quarantinePlacement?.transactionType === 'QUARANTINE_REMOVAL' && (history.state.quarantinePlacement?.documentStatus === 'DRAFT' || history.state.quarantinePlacement?.documentStatus === 'CONFIRMED' || history.state.quarantinePlacement?.documentStatus === 'CANCELLED')"
    />

  </div>


  <!--  footer-->
  <app-quarantine-placement-footer>
    <div card-left>
      <button (click)="returnToList()" class="button footer-button-back">
      <span>
        <svg fill="none" height="13" viewBox="0 0 14 13" width="14" xmlns="http://www.w3.org/2000/svg">
          <path clip-rule="evenodd"
                d="M5.78033 0.969668C6.07322 1.26256 6.07322 1.73744 5.78033 2.03033L2.81066 5H9.25C11.8733 5 14 7.12663 14 9.75V12.25C14 12.6642 13.6642 13 13.25 13C12.8358 13 12.5 12.6642 12.5 12.25V9.75C12.5 7.95507 11.0449 6.5 9.25 6.5H2.81066L5.78033 9.4697C6.07322 9.7626 6.07322 10.2374 5.78033 10.5303C5.48744 10.8232 5.01256 10.8232 4.71967 10.5303L0.469668 6.28033C0.176777 5.98744 0.176777 5.51256 0.469668 5.21967L4.71967 0.969668C5.01256 0.676777 5.48744 0.676777 5.78033 0.969668Z"
                fill="white"
                fill-rule="evenodd"/>
        </svg>
      </span>
        Відмінити
      </button>

      <ng-container *ngIf="(isEditQuarantineRemoval || isEditQuarantinePlacement) && isDraftDocument && canMakeActions">
        <button (click)="savePlacement()" class="button footer-button-white">
          Зберегти
        </button>
      </ng-container>
    </div>


    <div card-right>

      <ng-container *ngIf="(isEditQuarantineRemoval || isEditQuarantinePlacement) && isDraftDocument && canMakeActions">
        <button (click)="cancelPlacement()" class="button footer-button-back">
        <span>
           <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_28799_3254)">
            <path clip-rule="evenodd" d="M2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8ZM8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0Z"
                  fill="white"
                  fill-rule="evenodd"/>
            <rect fill="white" height="14" transform="rotate(45 11.8984 3)" width="2" x="11.8984" y="3"/>
            </g>
            <defs>
            <clipPath id="clip0_28799_3254">
            <rect fill="white" height="16" width="16"/>
            </clipPath>
            </defs>
          </svg>
        </span>
          Скасувати
        </button>
      </ng-container>

      <ng-container *ngIf="(isEditQuarantineRemoval || isEditQuarantinePlacement) && isDraftDocument && canMakeActions">
        <button (click)="confirmPlacement()" class="button footer-button-yellow">
          Підтвердити
          <span>
          <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 2L13 8M13 8L7 14M13 8L2 8" stroke="#1A1A1A" stroke-linecap="round" stroke-linejoin="round"
                  stroke-width="2"/>
          </svg>
        </span>
        </button>
      </ng-container>

      <ng-container *ngIf="isCreateQuarantinePlacement || isCreateQuarantineRemoval">
        <button (click)="createPlacement()" class="button footer-button-yellow">
          Зберегти
          <span>
          <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 2L13 8M13 8L7 14M13 8L2 8" stroke="#1A1A1A" stroke-linecap="round" stroke-linejoin="round"
                  stroke-width="2"/>
          </svg>
        </span>
        </button>
      </ng-container>

      <ng-container
          *ngIf="quarantinePlacement?.isRemovable">
        <button (click)="openModalConfirm()" class="button footer-button-yellow">
          Зняти з карантину
          <span>
          <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 2L13 8M13 8L7 14M13 8L2 8" stroke="#1A1A1A" stroke-linecap="round" stroke-linejoin="round"
                  stroke-width="2"/>
          </svg>
        </span>
        </button>
      </ng-container>

    </div>
  </app-quarantine-placement-footer>
</div>


<app-modal-confirm (confirm)="redirectToCreateQuarantineRemoval()"/>
<app-loading-animation *ngIf="isLoading"></app-loading-animation>
